export const AUTH_TYPE_BUTTON_LABEL = {
  login: 'Log In',
  signUp: 'Create Account',
  forgotPassword: 'Reset your password',
  resetPassword: 'Reset Password',
  resendVerification: 'Resend Verification Email',
};
